export default class BaseModal {
    constructor(template) {
        this.template = template;
        this.isDismissible = true;
        this.me = null;
    }

    show() {
        let temp = document.createElement('div');
        temp.innerHTML = this.template;

        let div = temp.querySelector('.modal__container');

        this.me = document.querySelector('body').appendChild(div);
        this.bindEvents();

        if (!this.isDismissible) {
            this.removeCloseButton();
        }
    }

    bindEvents() {
        if (this.isDismissible) {
            this.me.querySelector('.control__bar .button__close').addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }
        this.me.querySelector('.control__bar .button__close').focus();
    }

    removeCloseButton() {
        let tobeRemoved = this.me.querySelector('.control__bar .button__close');
        tobeRemoved.parentNode.removeChild(tobeRemoved);
    }

    setDismissible(state) {
        this.isDismissible = state;
    }

    close() {
        document.querySelector('body').removeChild(this.me);
    }
}
